export enum ProjectTagType {
    None = 'None',
    InvestRoiContribution = 'InvestRoiContribution',
    InnovationNoRoi = 'InnovationNoRoi',
    Sales = 'Sales',
    CostCollectionCustomerRelated = 'CostCollectionCustomerRelated',
    CostCollectionGMSInternal = 'CostCollectionGMSInternal',
    HQOrderCZ = 'HQOrderCZ',
    HQOrderRegion = 'HQOrderRegion',
    HQOrderUS = 'HQOrderUS'
}

export enum TagCategory {
    Category1 = 'Category1',
    Category2 = 'Category2'
}

export interface ProjectTags {
    id: number;
    translationKey: string;
    tag: ProjectTagType;
    category: TagCategory;
}
